import mutations from './mutations';
import actions from './actions/index';
import modules from './modules/index';

export default {
  state: {
    mentors: [],
    goals: [],
    tasks: [],
    goalGroup: undefined,
  },
  getters: {
    // [TODO] Should filter out the matched mentors
    myMentors(state) {
      return state.mentors;
    },
    // newMentors(state) {
    //   return state.mentors.filter(m => !toBoolean(m.status));
    // },
    getMentor: state => id => state.mentors.find(m => m.id === id),
    getTask: state => id => state.tasks.find(t => t.id === id),
    // getOngoingTasks: state => state.tasks.filter(),
    getMenteeGoal: state => id => state.goals.find(g => g === id),
  },
  mutations,
  actions,
  modules,
};
